import { render, staticRenderFns } from "./DeskInfoStatsList.vue?vue&type=template&id=6e84c42f&"
import script from "./DeskInfoStatsList.vue?vue&type=script&lang=js&"
export * from "./DeskInfoStatsList.vue?vue&type=script&lang=js&"
import style0 from "./DeskInfoStatsList.vue?vue&type=style&index=0&id=6e84c42f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e84c42f')) {
      api.createRecord('6e84c42f', component.options)
    } else {
      api.reload('6e84c42f', component.options)
    }
    module.hot.accept("./DeskInfoStatsList.vue?vue&type=template&id=6e84c42f&", function () {
      api.rerender('6e84c42f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/statistics/DeskInfoStatsList.vue"
export default component.exports